/**
 * `entities/taxonomy-campaign` query options factories.
 *
 * Calls the hey-api client directly by URL, matching the sibling taxonomy
 * slices. `assetsHttp` injects the `x-selected-workspace-id` header, so the
 * workspace scope is implicit — which is the whole scope a campaign has.
 */
import { queryOptions } from '@tanstack/react-query';
import { assetsHttp } from '@/lib/api/http-client';
import { parseResponse } from '@/lib/api/parse-response';
import { TAXONOMY_CAMPAIGN_QUERY_KEYS } from './query-keys';
import { taxonomyCampaignListSchema } from './schemas';

const CAMPAIGNS_URL = '/api/v1/taxonomy-campaigns';

export const taxonomyCampaignsQueryOptions = () =>
  queryOptions({
    queryKey: TAXONOMY_CAMPAIGN_QUERY_KEYS.list(),
    queryFn: async ({ signal }) => {
      const response = await assetsHttp.get({ throwOnError: true, url: CAMPAIGNS_URL, signal });
      return parseResponse(taxonomyCampaignListSchema, response);
    },
  });

export { CAMPAIGNS_URL };
